/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface EfectivizarPrestamoME { 
    usuarioId?: string;
    numeroCuentaOrigen?: number;
    numeroPrestamo?: number;
    concepto?: string;
    otp?: string;
    esDesdeMovil?: boolean;
    valor?: number;
    omitirOTP?:boolean;
}
